@if (!displayGraph && !isMobilePortrait) {
  <div class="no-graph">
    <img
      src="assets/imgs/undraw/undraw_blank_canvas.svg"
      alt="Nessun Grafico"
    />
    <span
      >Esegui l'analisi AI per almeno un appuntamento di questo paziente per
      visualizzare il trend dei topic nucleari</span
    >
  </div>
}

@if (isMobilePortrait) {
  <div class="no-graph">
    <span
      >Gira il dispositivo e ricarica la pagina per visualizzare il
      grafico</span
    >
  </div>
}

@if (displayGraph && !isMobilePortrait) {
  <div class="graph-ai container">
    <h1 class="graph-title">Topic Nucleari nel Tempo</h1>
    <div class="controls-container">
      <button mat-button (click)="hideShowNullCategories()">
        <mat-icon>{{
          hideNullCatDistr ? "visibility_off" : "visibility"
        }}</mat-icon>
        <span>Colloqui senza analisi</span>
      </button>
    </div>
    <div class="chart-container">
      <canvas #chart></canvas>
    </div>
    <div class="category-chips">
      <mat-chip-listbox>
        @for (category of categories; track category; let i = $index) {
          <mat-chip
            [style.background-color]="
              category.hidden ? '#f0f0f0' : colors[i % colors.length]
            "
            [style.color]="category.hidden ? '#000000' : '#ffffff'"
            (click)="toggleCategory(category)"
          >
            {{ nuclearTopicsLabels[category.name] }}
            <mat-icon matChipRemove>{{
              category.hidden ? "add" : "close"
            }}</mat-icon>
          </mat-chip>
        }
      </mat-chip-listbox>
    </div>
  </div>
}

@if (displayGraph && !isMobilePortrait) {
  <section class="topics-explanations">
    <h1 class="graph-title">Descrizione Topic Nucleari</h1>
    @for (topic of nuclearTopicsExplanation; track topic) {
      <div class="category-container">
        <span class="category-title">{{ topic.topic }}</span>
        <span class="category-description">{{ topic.description }}</span>
      </div>
    }
  </section>
}
